import { addMessages } from "svelte-i18n";
export function applyTranslationCorrection(locale, key, value) {
    addMessages(locale, toLocaleDictionary(key, value));
}
/**
 * This takes a record where the key is the dotted path e.g. "a.b.c" with a value and converts
 * it to a nested dictionary as used by svelte-i18n e.g. { a: { b: { c: value }}}
 */
function toLocaleDictionary(key, value) {
    const expanded = {};
    const keyParts = key.split(".");
    let level = expanded;
    keyParts.forEach((nestedKey, i) => {
        if (!level[nestedKey]) {
            if (i === keyParts.length - 1) {
                level[nestedKey] = value;
            }
            else {
                level[nestedKey] = {};
            }
        }
        level = level[nestedKey];
    });
    return expanded;
}
